<template>
  <el-container class="merchant-container">
    <el-aside width="220px">
      <div class="logo">
        <img src="@/assets/logo.png" alt="Logo" class="logo-img" v-if="false">
        <span>商家端</span>
      </div>
      <el-menu
        :default-active="activeMenu"
        class="el-menu-vertical"
        background-color="#1a1f2c"
        text-color="#a8b1c2"
        active-text-color="#409EFF"
        :collapse="isCollapse"
        :unique-opened="true"
        @select="handleSelect"
        :router="true">

        <el-menu-item index="/merchant/dashboard" class="top-level-menu">
          <i class="el-icon-s-home"></i>
          <span>首页</span>
        </el-menu-item>

        <el-submenu index="/merchant/orders">
          <template slot="title">
            <i class="el-icon-s-order"></i>
            <span>订单管理</span>
          </template>
          <el-menu-item index="/merchant/orders/all" class="tree-node">
            <i class="el-icon-tickets sub-menu-icon"></i>
            <span class="sub-menu-text">所有订单</span>
          </el-menu-item>
          <el-menu-item index="/merchant/orders/not-shipped" class="tree-node">
            <i class="el-icon-document sub-menu-icon"></i>
            <span class="sub-menu-text">未邮寄订单</span>
          </el-menu-item>
          <el-menu-item index="/merchant/orders/in-transit" class="tree-node">
            <i class="el-icon-truck sub-menu-icon"></i>
            <span class="sub-menu-text">在途订单</span>
          </el-menu-item>
          <el-menu-item index="/merchant/orders/testing" class="tree-node">
            <i class="el-icon-loading sub-menu-icon"></i>
            <span class="sub-menu-text">测试中订单</span>
          </el-menu-item>
          <el-menu-item index="/merchant/orders/tested" class="tree-node">
            <i class="el-icon-check sub-menu-icon"></i>
            <span class="sub-menu-text">已测试订单</span>
          </el-menu-item>
          <el-menu-item index="/merchant/orders/completed" class="tree-node">
            <i class="el-icon-circle-check sub-menu-icon"></i>
            <span class="sub-menu-text">已完成订单</span>
          </el-menu-item>
          <el-menu-item index="/merchant/orders/expiring" class="tree-node">
            <i class="el-icon-alarm-clock sub-menu-icon"></i>
            <span class="sub-menu-text">即将/已超期订单</span>
          </el-menu-item>
          <el-menu-item index="/merchant/orders/unsettled" class="tree-node">
            <i class="el-icon-money sub-menu-icon"></i>
            <span class="sub-menu-text">未结算订单</span>
          </el-menu-item>
          <el-menu-item index="/merchant/orders/return" class="tree-node">
            <i class="el-icon-back sub-menu-icon"></i>
            <span class="sub-menu-text">回寄/转寄订单</span>
          </el-menu-item>
          <el-menu-item index="/merchant/orders/dispute" class="tree-node">
            <i class="el-icon-warning sub-menu-icon"></i>
            <span class="sub-menu-text">争议/复测订单</span>
          </el-menu-item>
        </el-submenu>
        
        <el-menu-item index="/merchant/settlement/monthly" class="top-level-menu">
          <i class="el-icon-s-finance"></i>
          <span>月结算表单</span>
        </el-menu-item>
        
        <el-menu-item index="/merchant/devices" class="top-level-menu">
          <i class="el-icon-data-analysis"></i>
          <span>仪器管理</span>
        </el-menu-item>
      </el-menu>
    </el-aside>
    
    <el-container>
      <el-header>
        <div class="header-left">
          <i 
            :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'" 
            @click="toggleSidebar"
          ></i>
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/merchant/dashboard' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item v-if="currentRoute.meta && currentRoute.meta.title">
              {{ currentRoute.meta.title }}
            </el-breadcrumb-item>
            <el-breadcrumb-item v-if="currentRoute.meta && currentRoute.meta.subTitle">
              {{ currentRoute.meta.subTitle }}
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="header-right">
          <el-dropdown trigger="click">
            <span class="el-dropdown-link">
              <i class="el-icon-user"></i>
              {{ userName }} <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="$router.push('/merchant/profile')">个人信息</el-dropdown-item>
              <el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      
      <el-main>
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: 'MerchantLayout',
  data() {
    return {
      isCollapse: false,
      userName: '商家'
    }
  },
  mounted() {
    // 初始化时确保菜单项高亮
    this.enforceMenuActiveState();
    // 获取用户信息
    this.getUserInfo();
  },
  computed: {
    activeMenu() {
      return this.$route.path;
    },
    currentRoute() {
      return this.$route
    }
  },
  watch: {
    '$route'(to, from) {
      // 路由变化时保持菜单高亮
      this.$nextTick(() => {
        this.enforceMenuActiveState();
      });
    }
  },
  methods: {
    enforceMenuActiveState() {
      // 强制保持菜单项高亮
      this.$nextTick(() => {
        const activeItems = document.querySelectorAll('.el-menu-item.is-active');
        activeItems.forEach(item => {
          item.style.backgroundColor = '#409EFF';
          item.style.color = 'white';
        });
        
        // 确保所有子菜单标题正确对齐
        const submenuTitles = document.querySelectorAll('.el-submenu__title');
        submenuTitles.forEach(title => {
          // 确保flex布局
          title.style.display = 'flex';
          title.style.alignItems = 'center';
          title.style.paddingLeft = '20px';
          
          const icon = title.querySelector('i');
          if (icon) {
            icon.style.width = '24px';
            icon.style.textAlign = 'center';
            icon.style.marginRight = '5px';
            icon.style.fontSize = '18px';
          }
          
          // 确保所有span元素对齐
          const span = title.querySelector('span');
          if (span) {
            span.style.marginLeft = '5px';
          }
        });
        
        // 顶层菜单项样式
        const topLevelMenus = document.querySelectorAll('.top-level-menu');
        topLevelMenus.forEach(item => {
          item.style.paddingLeft = '20px';
          
          const icon = item.querySelector('i');
          if (icon) {
            icon.style.width = '24px';
            icon.style.textAlign = 'center';
            icon.style.fontSize = '18px';
            icon.style.marginRight = '5px';
          }
          
          const span = item.querySelector('span');
          if (span) {
            span.style.marginLeft = '5px';
          }
        });
      });
    },
    toggleSidebar() {
      this.isCollapse = !this.isCollapse;
    },
    handleSelect(key, keyPath) {
      // 菜单选择处理
    },
    logout() {
      // 退出登录
      this.$confirm('确定退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 清除登录状态
        localStorage.removeItem('token');
        localStorage.removeItem('userInfo');
        // 跳转到登录页
        this.$router.push('/merchant/login');
      }).catch(() => {
        // 取消退出
      });
    },
    getUserInfo() {
      try {
        const userInfoStr = localStorage.getItem('userInfo');
        if (userInfoStr) {
          const userInfo = JSON.parse(userInfoStr);
          if (userInfo && userInfo.userName) {
            this.userName = userInfo.userName;
          }
        }
      } catch (error) {
        console.error('获取用户信息失败:', error);
      }
    }
  }
}
</script>

<style scoped>
.merchant-container {
  height: 100vh;
}

.el-aside {
  background-color: #1a1f2c;
  height: 100%;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.el-header {
  background-color: white;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
}

.header-left {
  display: flex;
  align-items: center;
}

.header-left i {
  font-size: 20px;
  cursor: pointer;
  margin-right: 15px;
  color: #606266;
}

.header-left i:hover {
  color: #409EFF;
}

.header-right {
  display: flex;
  align-items: center;
}

.el-dropdown-link {
  cursor: pointer;
  color: #606266;
  display: flex;
  align-items: center;
}

.el-dropdown-link:hover {
  color: #409EFF;
}

.el-dropdown-link i {
  margin-right: 5px;
}

.logo {
  height: 60px;
  line-height: 60px;
  color: white;
  font-size: 18px;
  text-align: center;
  font-weight: bold;
  letter-spacing: 1px;
  border-bottom: 1px solid #2c3344;
  background-color: #151a24;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-img {
  height: 30px;
  margin-right: 10px;
}

.el-menu-vertical:not(.el-menu--collapse) {
  width: 220px;
  border-right: none;
}

.el-menu-item, .el-submenu__title {
  height: 50px;
  line-height: 50px;
  padding-left: 20px !important;
  display: flex;
  align-items: center;
}

/* 确保图标和文字对齐 */
.el-menu-item i, .el-submenu__title i {
  margin-right: 5px;
  width: 24px;
  text-align: center;
  font-size: 18px;
}

.el-menu-item span, .el-submenu__title span {
  margin-left: 5px;
}

.top-level-menu {
  padding-left: 20px !important;
}

/* 菜单激活状态样式 */
.el-menu-item.is-active {
  background-color: #409EFF !important;
  color: white !important;
}

.el-menu-item.is-active i {
  color: white !important;
}

/* 子菜单激活状态 */
.el-submenu.is-active > .el-submenu__title {
  color: #409EFF !important;
  background-color: #2c3344 !important;
}

.el-submenu.is-active > .el-submenu__title i {
  color: #409EFF !important;
}

.el-submenu__title:hover, .el-menu-item:hover {
  background-color: #2c3344 !important;
}

/* 子菜单项样式 */
.tree-node {
  padding-left: 40px !important;
  display: flex;
  align-items: center;
}

.tree-node.is-active {
  background-color: #409EFF !important;
  color: white !important;
}

.tree-node.is-active i {
  color: white !important;
}

.tree-node:hover {
  background-color: #2c3344 !important;
}

.sub-menu-icon {
  margin-right: 5px;
  font-size: 14px;
  width: 18px;
  text-align: center;
}

.sub-menu-text {
  font-size: 13px;
  margin-left: 5px;
}

.el-main {
  background-color: #f5f7f9;
  padding: 20px;
  overflow-x: hidden;
}
</style> 